import React, {useState, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {getTicket, updateTicket} from "../api/OrdersAPI";
import {showError} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";
import Header from "../../../layouts/Header";

import emptyCart from "../../../assets/images/empyCart.png";
import Navbar from "../../../layouts/Navbar";

import {IoCall, IoCloudDownloadOutline, IoSend} from "react-icons/io5";

import {TiAttachmentOutline} from "react-icons/ti";

// --- موارد اضافه شده برای ضبط صدا ---
import { useReactMediaRecorder } from "react-media-recorder";
import { FaMicrophone, FaTimes  } from "react-icons/fa";

import ChatMessageAudioPlayer from "./ChatMessageAudioPlayer";
import WebphoneFrame from "../../products/components/WebphoneFrame";
import {VscCheck} from "react-icons/vsc";


// تابع برای پیدا کردن بهترین فرمت و کدک پشتیبانی شده
const getSupportedMimeType = () => {
    const possibleTypes = [
        // اولویت اول: MP4 با کدک AAC-LC برای سازگاری حداکثری با iOS
        'audio/mp4; codecs=mp4a.40.2',
        // اولویت دوم: فرمت کلی MP4
        'audio/mp4',
        // گزینه‌های جایگزین برای مرورگرهای دیگر
        'audio/webm; codecs=opus',
        'audio/webm',
    ];

    // برخی مرورگرها در صورت عدم پشتیبانی کدک خطا می‌دهند، پس از try-catch استفاده می‌کنیم
    return possibleTypes.find(type => {
        try {
            return MediaRecorder.isTypeSupported(type);
        } catch (e) {
            return false;
        }
    });
};

const audioContextRef = React.createRef();
if (!audioContextRef.current) {
    // این کد فقط یک بار اجرا می‌شود
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (AudioContext) {
        audioContextRef.current = new AudioContext();
    }
}
// تابعی برای فعال‌سازی AudioContext
const resumeAudioContext = async () => {
    if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
        try {
            await audioContextRef.current.resume();
            console.log('AudioContext با موفقیت فعال شد.');
        } catch (e) {
            console.error('خطا در فعال‌سازی AudioContext:', e);
        }
    }
};

const isIPhone = () => {
    // این عبارت به دنبال کلمات کلیدی iPhone, iPod یا iPad در User Agent می‌گردد.
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

const Ticket = () => {
    const {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [showCall, setShowCall] = useState(0);
    // مقدار اولیه ticket را null قرار می‌دهیم تا بررسی آن ساده‌تر باشد
    const [ticket, setTicket] = React.useState(null);
    const [message, setMessage] = React.useState('');
    const [file, setFile] = React.useState(null);
    const textareaRef = useRef(null);
    const fileInputRef = useRef(null);

    const navigate = useNavigate();

    const mimeType = getSupportedMimeType() || 'audio/webm'; // انتخاب بهترین فرمت یا بازگشت به webm

    const isSendingAudio = useRef(false); // این خط را اضافه کن
    const isCancelled = useRef(false);

    const {
        status,
        startRecording,
        stopRecording,
        clearBlobUrl,
        mediaBlobUrl, // این را برگرداندیم
    } = useReactMediaRecorder({
        audio: true,
        video: false,
        mediaRecorderOptions: {
            mimeType: mimeType
        }
        // onStop را کاملا حذف کردیم
    });


    const handleCancelRecording = () => {
        isCancelled.current = true; // علامت‌گذاری به عنوان انصراف
        stopRecording(); // توقف ضبط (که باعث تریگر شدن افکت میشه)
    };
    const handleStopAndSend = () => {
        isCancelled.current = false; // این یعنی انصراف نیست، ارساله
        stopRecording();
    };

    const handleStartRecording = () => {
        resumeAudioContext(); // اولین قدم، فعال‌سازی کانتکست
        startRecording();
    };




    React.useEffect(() => {
        setLoading(true);
        const fetchTicket = async () => {
            try {
                const params = {

                }
                const data = await getTicket(id, params);
                setTicket(data.data);
                setTimeout(() => {
                    window.scrollTo({
                        top: document.body.scrollHeight, // ارتفاع کل صفحه
                        behavior: 'smooth'
                    });
                }, 400);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchTicket();
    }, [id]);

    const onFileChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setFile(event.target.files[0]);
        }
    }


    const onSendPress = async () => {
        if (message.length < 1 && !file) { // شرط به 1 تغییر کرد تا پیام‌های کوتاه هم ارسال شوند
            showError('لطفا پیامی بنویسید یا فایلی را ضمیمه کنید');
            return false;
        }

        const formData = new FormData();

        if (file) {
            formData.append('file', file);
        }

        if (!message) {
            if (file.type.startsWith('audio/')) {
                formData.append('message', 'پیام صوتی');
            }
            else {
                formData.append('message', 'ارسال فایل ');
            }

        }

        else {
            formData.append('message', message);
        }


        formData.append('_method', 'PATCH');

        try {
            setLoading2(true)
            await updateTicket(id, formData);
            setMessage('')
            if (textareaRef.current) {
                textareaRef.current.style.height = "auto";
                // اگر ارتفاع اولیه‌ی خاصی مد نظرتان است (مثلاً 40px)، آن را اینجا بنویسید
                // textareaRef.current.style.height = "40px";
            }
            setFile(null)
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            clearBlobUrl(); // پاک کردن آدرس صدای ضبط شده قبلی
            const params = {

            }
            const data = await getTicket(id, params);
            setTicket(data.data);
            setTimeout(() => {
                window.scrollTo({
                    top: document.body.scrollHeight , // ارتفاع کل صفحه
                    behavior: 'smooth'
                });
            }, 400);
        } catch (err) {
            showError(err);
        } finally {
            setLoading2(false);
        }
    }

// ارسال خودکار صدا بلافاصله پس از توقف ضبط
    React.useEffect(() => {
        // اگر کاربر دوباره شروع به ضبط کرد، قفل ارسال را باز کن تا برای ضبط بعدی آماده باشد
        if (status === 'recording') {
            isSendingAudio.current = false;
            isCancelled.current = false;
        }

        if (status === 'stopped' && mediaBlobUrl && !isSendingAudio.current  && !isCancelled.current) {
            // بلافاصله قفل را فعال کن تا از ارسال تکراری جلوگیری شود
            isSendingAudio.current = true;

            const sendAudio = async () => {
                try {
                    setLoading2(true);
                    const response = await fetch(mediaBlobUrl);
                    const blob = await response.blob();

                    const fileExtension = mimeType.split('/')[1].split(';')[0];
                    const audioFile = new File([blob], `voicemessage.${fileExtension}`, { type: mimeType });

                    const formData = new FormData();
                    formData.append('file', audioFile);
                    formData.append('message', 'پیام صوتی');
                    formData.append('_method', 'PATCH');

                    await updateTicket(id, formData);

                    clearBlobUrl();

                    const data = await getTicket(id, {});
                    setTicket(data.data);
                    setTimeout(() => {
                        window.scrollTo({
                            top: document.body.scrollHeight , // ارتفاع کل صفحه
                            behavior: 'smooth'
                        });
                    }, 400);
                } catch (err) {
                    showError(err);
                    // در صورت خطا، قفل را باز کن تا کاربر بتواند دوباره تلاش کند (اختیاری)
                    isSendingAudio.current = false;
                } finally {
                    setLoading2(false);
                }
            };
            sendAudio();
        }
        else if (status === 'stopped' && isCancelled.current) {
            // اگر کنسل شده بود، فقط Blob رو پاک کن
            clearBlobUrl();
        }
    }, [status, mediaBlobUrl, clearBlobUrl, id, mimeType]);



    // تابع برای حذف فایل یا صدای ضبط شده
    const handleClearFile = () => {
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }

    }

    const handleInput = (e) => {
        setMessage(e.target.value);
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto"; // اول ریست شود
            textarea.style.height = textarea.scrollHeight + "px"; // بعد هم اندازه متن شود
        }
    };

    const linkifyText = (text) => {
        // پرانتز ( ) در اسپلیت باعث می‌شود خود لینک هم در آرایه خروجی بیاید
        const urlRegex = /(https?:\/\/[^\s]+)/g;

        // اگر text null یا undefined بود
        if (!text) return "";

        return text.split(urlRegex).map((part, index) => {
            if (part.match(urlRegex)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        // استایل دلخواه برای لینک‌ها
                        style={{color: '#007bff', textDecoration: 'underline'}}
                        // برای جلوگیری از انتشار کلیک به والد (مثلا باز شدن مودال)
                        onClick={(e) => e.stopPropagation()}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };


    if (loading) return <Loading/>;

    if (!ticket || Object.keys(ticket).length === 0) {
        return (
            <React.Fragment>
                <Header hasBack={true} transparent={false} title='اطلاعات پیش فاکتور '/>

                <section className="container-fluid vertical-center  ">

                    <div className="row mobile-size-option">

                        <div className="col-12 text-center mb-3 ">
                            <img src={emptyCart} alt="Loading" className='w-50 black-white'/>
                        </div>
                        <div className="col-12 text-center text-big-2 mt-4 ">
                            درخواست مورد نظر پیدا نشد
                        </div>
                    </div>
                </section>
                <Navbar/>
            </React.Fragment>
        )
    }




    return (
        <React.Fragment>
            <Header hasBack={true} transparent={false} title={'در حال صحبت با ' + ticket?.vendor.title}/>
            <section className="container-fluid" id='chat-header'>
                <div className="row mx-2 py-2">
                    <div className="col-3">
                        <img src={ticket.product?.image} alt={ticket.title} width='40px'

                             onClick={
                                 () => {
                                     navigate(`/product/${ticket.product?.id}`)
                                 }
                             }
                        />
                    </div>
                    <div className="col-9 title text-justify">
                        {ticket.title}
                        {" "}
                        (
                        تعداد:
                        &nbsp;
                        {ticket.product?.count}
                        )
                        <span className='badge rounded  float-start   px-2 py-1 mt-2 text-warning-emphasis' style={{
                            backgroundColor: showCall > 0 ? 'rgba(209,209,209,0.32)' : '#fb790042',

                        }}
                        onClick={() => {setShowCall(1-showCall)}}
                        >

                         تماس
                               <IoCall className='me-1 text-big-3 text-warning-emphasis' />
                                                        </span>

                    </div>
                </div>
                {
                    showCall > 0 && <div className="row pb-3">
                        <div className="col-12 mt-1">
                            <WebphoneFrame name={ticket?.vendor.title} phone={ticket?.vendor.phone}
                                           webphone={ticket?.user.webphone_data}/>
                        </div>
                    </div>
                }

            </section>


            <section className="container my-5 py-5 bg-white">

                <div className="row mt-5">
                    <div className="col-12 my-4 order-0 app-chat ">
                        <ul className='list-unstyled chat-history mb-0 px-0'>

                        {
                                ticket?.messages?.map(message => {
                                    let $mes = message.message;
                                    $mes = $mes.replace("/storage/", "https://api.homestylee.com/storage/")

                                    return (

                                        <li className="chat-message chat-message-right mb-3" key={message.id}>
                                            <div className="d-flex overflow-hidden">
                                                {
                                                    message.type === 'B' &&
                                                    <div className="user-avatar flex-shrink-0 ms-3">
                                                        <div className="avatar avatar-sm">
                                                            <img src={message.avatar} alt="Avatar"
                                                                 className="rounded-circle bg-secondary"
                                                                 width='30px' height='30px' style={{
                                                                objectFit: "contain"
                                                            }}/>
                                                        </div>
                                                    </div>
                                                }

                                                <div className="chat-message-wrapper flex-grow-1 w-50">
                                                    <div className=" px-3 py-2 rounded" style={{
                                                        background: message.type === 'B' ? 'rgb(247 247 247)' : 'rgb(236 236 236)'
                                                    }}>
                                                        <p className="mb-0 ">
                                                            <div className='text-small-2 opacity-75 mb-1'>
                                                                {
                                                                    message.user
                                                                }
                                                            </div>
                                                            <p className='text-justify'
                                                               style={{whiteSpace: 'pre-wrap'}}>
                                                                {linkifyText($mes)}
                                                            </p>
                                                            {message.file?.length > 3 && (() => {
                                                                // استخراج پسوند فایل و تبدیل آن به حروف کوچک
                                                                const fileExtension = message.file.split('.').pop().toLowerCase();
                                                                const fullFileUrl = message.file.startsWith('http') ? message.file : `https://www.indev.ir/storage/${message.file}`;

                                                                // تشخیص نوع فایل بر اساس پسوند
                                                                if (['mp3', 'wav', 'ogg', 'webm', 'm4a', 'mp4'].includes(fileExtension)) {
                                                                    // اگر فایل صوتی بود، پلیر صدا نمایش داده شود
                                                                    return (
                                                                        <ChatMessageAudioPlayer src={fullFileUrl}/>
                                                                    );
                                                                } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(fileExtension)) {
                                                                    // اگر فایل تصویر بود، تصویر به همراه لینک نمایش داده شود
                                                                    return (
                                                                        <div className="message-image-preview my-2">
                                                                            <a href={fullFileUrl} target="_blank"
                                                                               rel="noopener noreferrer">
                                                                                <img src={fullFileUrl} alt="تصویر ضمیمه"
                                                                                     className="img-thumbnail" style={{
                                                                                    maxWidth: '200px',
                                                                                    maxHeight: '200px',
                                                                                    cursor: 'pointer'
                                                                                }}/>
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                } else {
                                                                    // برای سایر فایل‌ها، لینک دانلود نمایش داده شود
                                                                    return (
                                                                        <div className='text-start my-2'>
                                                                            <a href={fullFileUrl} target='_blank'
                                                                               rel="noopener noreferrer"
                                                                               className='btn btn-link link-primary text-small-2 d-flex align-items-center'>
                                                                                <IoCloudDownloadOutline
                                                                                    className='mx-2'/>
                                                                                دانلود فایل الحاقی
                                                                                ({fileExtension.toUpperCase()})
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                }
                                                            })()}
                                                        </p>
                                                        {/*       <div className="text-start mt-3">
                                                             <span className=' text-primary text-small-2 py-1 px-2 rounded '
                                                                   style={{backgroundColor: 'rgb(33 ,150, 243 , .12)'}}>
                                                            پاسخ
                                                            <VscReply className='mx-1'/>
                                                        </span>
                                                        </div>*/}
                                                               <div className="float-start">
                                                                   {
                                                                       message.is_seen > 0 ?

                                                                           <span
                                                                               className=' text-secondary text-small-3 py-1 rounded '

                                                                               title='خوانده شده'
                                                                           >

                                                            <VscCheck />
                                                            <VscCheck />
                                                        </span> :
                                                                           <span
                                                                               className=' text-secondary text-small-3 py-1  rounded '

                                                                           title='خوانده نشده'
                                                                           >


                                                            <VscCheck />
                                                        </span>
                                                                   }

                                                               </div>
                                                    </div>

                                                    <div className="text-end text-muted opacity-50 mx-2">
                                                        <i className="bx bx-check-double"></i>
                                                        <small className='text-small-3'>
                                                            {message.date}

                                                        </small>
                                                    </div>

                                                </div>
                                                {
                                                    message.type === 'F' &&
                                                    <div className="user-avatar flex-shrink-0 me-3">
                                                        <div className="avatar avatar-sm">
                                                            <img src={message.avatar} alt="Avatar"
                                                                 className="rounded-circle bg-secondary"
                                                                 width='30px' height='30px' style={{
                                                                objectFit: "contain"
                                                            }}/>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <div className="col-12 text-center">
                        {
                            loading2 &&

                            <div className="spinner-grow" role="status">
                                <span className="visually-hidden">در حال ارسال</span>
                            </div>
                        }

                    </div>
                </div>


                <div className="message-bar mobile-size-option">

                    <div className="message-bar__actions">
                        {message.length > 0 || file ? (
                            <button onClick={onSendPress} className="message-bar__button is-send py-2">
                                {
                                    loading2 ?

                                    <div className="spinner-grow" role="status">

                                    </div>
                                        :
                                        <IoSend className='ms-1' />
                                }

                            </button>
                        ) : status === 'recording' ? (
                            <button onClick={handleStopAndSend} className="message-bar__button is-send py-2">
                                <IoSend className='ms-1'  />
                            </button>

                        ) : (
                            <button onClick={handleStartRecording} className="message-bar__button is-mic">
                                <FaMicrophone/>
                            </button>
                        )}
                    </div>
                    <div className="message-bar__input-wrapper">

                        {status === 'recording' ? (
                            <div className="message-bar__status is-recording">درحال ضبط...

                                <span
                                    onClick={handleCancelRecording}
                                    className="text-big-5"
                                    title="انصراف"
                                >
                                    <FaTimes size={30}/>
                                </span>
                            </div>

                        ) : (
                            <textarea
                                ref={textareaRef}
                                className="message-bar__textarea"
                                placeholder="پاسخ خود را بنویسید..."
                                value={message}
                                onChange={handleInput}
                                disabled={loading2}
                                onInput={handleInput}
                                rows="1"
                            />
                        )}
                    </div>
                    <label htmlFor="file-input" className="message-bar__button">
                        {file && (
                            <span
                                className='badge bg-third-color text-white position-absolute  translate-middle rounded-pill text-small-4'>
                   1
                </span>
                        )}
                        <TiAttachmentOutline/>

                    </label>
                    <input id="file-input" type="file" ref={fileInputRef} className="d-none" onChange={onFileChange}/>

                </div>


            </section>
        </React.Fragment>
    );


};

export default Ticket;